import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../../service/auth/auth.service';
import { PluginService } from '../../service/plugin.service';
import { ReqResService } from '../../service/req-res.service';

declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-productlist',
  templateUrl: './productlist.component.html',
  styleUrls: ['./productlist.component.css']
})
export class ProductlistComponent implements OnInit {

  productData: any[] = [];
  searchText: string = '';
  public _pluginservice: any;
  private readonly defaultImage = '../assets/img/products/0.png';

  currentPage: number = 1;
  pageSize: number = 50;

  selectedGroupId: string = '';
  itemGroups: any[] = [];

  constructor(
    private reqRes: ReqResService,
    private pluginservice: PluginService,
    private authService: AuthService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Product List');
    this._pluginservice = this.pluginservice;
  }

  ngOnInit(): void {
    this.loadProductData();
  }

  loadProductData() {
    this.reqRes.getData('/Product/GetItemsList').subscribe(
      (data: any) => {
        this.productData = (data || []).map((item: any) => ({
          ...item,
          img: item.img || this.defaultImage,
          orderQty: item.orderQty || 0
        }));
        this.prepareGroups();
        this.currentPage = 1;
      },
      error => {
        toastr.error('Oops! Something went wrong', '', { timeOut: 1000 });
        console.log(error);
      }
    );
  }

  prepareGroups() {
    const uniqueGroups: any[] = [];

    this.productData.forEach((item: any) => {
      const exists = uniqueGroups.some((g: any) => g.groupId == item.groupId);

      if (!exists && item.groupId != null) {
        uniqueGroups.push({
          groupId: item.groupId,
          groupName: item.groupName
        });
      }
    });

    uniqueGroups.sort((a: any, b: any) =>
      (a.groupName || '').localeCompare(b.groupName || '')
    );

    this.itemGroups = uniqueGroups;
  }

  get filteredProducts(): any[] {
    let filtered = [...this.productData];

    if (this.selectedGroupId !== '' && this.selectedGroupId != null) {
      filtered = filtered.filter((p: any) => String(p.groupId) === String(this.selectedGroupId));
    }

    if (this.searchText && this.searchText.trim()) {
      const search = this.searchText.toLowerCase().trim();

      filtered = filtered.filter((p: any) =>
        (p.itemName && p.itemName.toLowerCase().includes(search)) ||
        (p.groupName && p.groupName.toLowerCase().includes(search)) ||
        (p.itemCode && p.itemCode.toLowerCase().includes(search)) ||
        (p.price != null && p.price.toString().includes(search))
      );
    }

    return filtered;
  }

  get totalPages(): number {
    return Math.ceil(this.filteredProducts.length / this.pageSize) || 1;
  }

  get pagedProducts(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.filteredProducts.slice(startIndex, startIndex + this.pageSize);
  }

  get startItem(): number {
    if (this.filteredProducts.length === 0) return 0;
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get endItem(): number {
    const end = this.currentPage * this.pageSize;
    return end > this.filteredProducts.length ? this.filteredProducts.length : end;
  }

  get pages(): number[] {
    const pagesArray: number[] = [];
    for (let i = 1; i <= this.totalPages; i++) {
      pagesArray.push(i);
    }
    return pagesArray;
  }

  onSearchChange() {
    this.currentPage = 1;
  }

  onGroupChange() {
    this.currentPage = 1;
  }

  clearGroupFilter() {
    this.selectedGroupId = '';
    this.currentPage = 1;
  }


  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // smooth scroll
    });
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.scrollToTop();
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.scrollToTop();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.scrollToTop();
    }
  }

  trackByProduct(index: number, item: any): any {
    return item?.id || item?.itemCode || index;
  }

  trackByGroup(index: number, item: any): any {
    return item?.groupId || index;
  }



  increaseQty(product: any) {
    if (!product.orderQty) {
      product.orderQty = 0;
    }
    product.orderQty++;
  }

  decreaseQty(product: any) {
    if (!product.orderQty || product.orderQty <= 0) {
      product.orderQty = 0;
      return;
    }
    product.orderQty--;
  }


  addToCart(product: any) {
    const qty = Number(product.orderQty || 0);

    if (qty <= 0) {
      toastr.warning('Please enter quantity', '', { timeOut: 1000 });
      return;
    }

    const userKey = this.getCurrentUserKey();
    const storageKey = `basket_${userKey}`;

    let basket = JSON.parse(localStorage.getItem(storageKey) || '[]');

    const existing = basket.find((x: any) => x.itemCode === product.itemCode);

    if (existing) {
      existing.orderQty += qty;
    } else {
      basket.push({
        itemId: product.itemId,
        itemCode: product.itemCode,
        itemUnit: product.itemUnit,
        itemName: product.itemName,
        price: product.price,
        img: product.img,
        groupId: product.groupId,
        groupName: product.groupName,
        qty: product.qty,
        orderQty: qty
      });
    }

    localStorage.setItem(storageKey, JSON.stringify(basket));
    window.dispatchEvent(new Event('basketUpdated'));
    toastr.success('Added to cart', '', { timeOut: 2000 });

    product.orderQty = 0; // reset
  }

  getCurrentUserKey(): string {
    const user = this.authService.getuserid().toString();
    return user;
  }


  selectedImage: string = '';
  openImagePreview(img: string): void {
    this.selectedImage = img || this.defaultImage;

    ($('#imagePreviewModal') as any).modal('show');
  }

  onImageError(event: any): void {
    if (event?.target && event.target.src !== this.defaultImage) {
      event.target.src = this.defaultImage;
    }
  }

}
